export enum LoginType {
  company = 'company',
  investor = 'investor',
  admin = 'admin',
}
